import { DeviceEnum, UserAgent } from '@/src/interfaces/missing-types';

export function getDeviceType(userAgent: UserAgent) {
  if (userAgent.isMobile) return DeviceEnum.Mobile;
  if (userAgent.isTablet) return DeviceEnum.Tablet;
  return DeviceEnum.Desktop;
}
